import { TextField } from "@fluentui/react";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { PanelDrawer } from "../../../../../components/Panel/PanelDrawer";
import { UsePanelNuevoIncidente } from "./UsePanelNuevoIncidente";
import { useCallback } from "react";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";

export const PanelNuevoIncidente=(props:IOpenPanel)=>{
    const {request,setRequest,postInsertarIncidente,loading,disableForm,reset,mensaje,status} = UsePanelNuevoIncidente(props)
    const onRenderFooter = useCallback(
        () => (
          <>
            <PanelFooter
              texto="Guardar"
              texto2={"Salir"}
              disableButton={disableForm}
              onClick={postInsertarIncidente}
              onDismiss={() => {
                 reset()
              }}
            />
          </>
        ),
        [disableForm,request]
      );
    return (
        <PanelDrawer isOpen={props.isOpen} onDismiss={reset} onRenderFooter={onRenderFooter}
        textHeader={"Agregar Nuevo Incidente"} status={status} mensaje={mensaje} loading={loading}>
        <TextField 
         type="text"
         label="Nombre de incidente"
         placeholder="Escribir aquí el nombre del incidente"
         autoComplete="off"
         value={request.nombreIncidente}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,nombreIncidente:newValue})}
         }}
         />

        </PanelDrawer>
    )
}